// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BarController from "./bar_controller"
application.register("bar", BarController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RedactController from "./redact_controller"
application.register("redact", RedactController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
